// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ErrorUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function fromString(status) {
  switch (status) {
    case "active" :
        return /* Active */0;
    case "inactive" :
        return /* Inactive */1;
    default:
      return ErrorUtils$Catalyst.raiseError("CampaignStatus.re", "Invalid 'status' ", status);
  }
}

function toString(status) {
  if (status) {
    return "inactive";
  } else {
    return "active";
  }
}

export {
  fromString ,
  toString ,
  
}
/* No side effect */
